import React from "react";

// Icons
import ArrowRightIcon from "assets/icons/ArrowRightIcon";

// Asset
import ISAAcademyWorkshopCatalogue from "assets/document/ISA-Academy-2025-Catalog.pdf";
import banner_2 from "pages/assets/home/images/banner_2.jpg";

// React Slideshow Image
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

function Home() {
  const activity_posts = [
    {
      title: "Sustainability Workshop by United Tractors",
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/bb214b30a6e5ad17eca334bf89c99dce8d0e9ae1d61bbef58d6ded9df1e889a7d607b69ad67b8369092849ccbcb332792fd3432cd4b16b278417c259770a8820d65b2d475836b3695831bea68928f3d5bb557040ee00c4ddc9a0369c043f0bc157376d63ae85b51a12f474c37c47c1107677b0d51d0c8b044b3f/rez-file-1739249864480.png",
    },
    {
      title:
        "“ESG Risk Assessment and Double Materiality” Workshop by ISA Academy",
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/d95c96a83ace25a7d5879dea9f575823b0d819220bb17b4eeb6e81fe9fc6cc688ab2e900796a356a88fd7397d77cc44037da2ecd0f3678802430e5af87ffcbe67c53dae02080c96d4f49d4a38dae527dd0fe688fae702cfb78fc2647d8545eb0e4313b2f0625d1e0001af3390faddaebf4110582dca24db0101d/rez-file-1739249887629.png",
    },
    {
      title:
        "“ESG, CSR, GRI, SDGs Concept, Issues, and Context” Workshop by ISA Academy",
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/4ca1cec54c5328b7c597c514a8a1f03dad07c43124a3f0b215c66f84a68f1f0f9d5d6f8ddbae03804f06f3014ef4543fcdd0f8ab7fa4405716b9b6f4164c55ccd4f3081b78f0d5f54e0a974025581b90f83b77e41cb54727fe269e7e95776e32ff93443460c3566d5760e73f43159ee8ea7e9e2c2f191f480002/rez-file-1739250099355.png",
    },
    {
      title:
        "“ESG-Linked Community Development & Exit Strategy” Webinar by ISA Academy",
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/a1e07ce65ebadc51f1bafb7b5a910905771bc569f19e223f9b4747e78b9f8bb533514dde12e10064299e1600164bb54043b1c05b2e49ad6f41d0f8c5ab0e4947f191b42517371658c906d271680ca0514c66ebc0f22027bc4869fa16c91a3cf0200d3b2a34284e92c55afbe2413809f5877e7277337c1a814378/rez-file-1739250141419.png",
    },
    {
      title: "“ESG Trends 2025: Navigating The Future” Workshop by ISA Academy",
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/ce3a861d9b64132d41bc9eee69f4256c7252526e54bc067a26d60486243ea222a64069a4b6bdeb1b27579c45b8f5e9ca7d342c20388d93d8f69045d978e0e2af992a3039c583def6921eaa384853ff29edce22ed18645f9ad3c81440053c1c6e461c3df53748aa8b2ebc07b01ff66b8a6232e4d895c43c954ed0/rez-file-1739250219778.png",
    },
    {
      title: "“Why ESG Is Never Too Early” Webinar by ISA Academy",
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/ef6b30fce18da509d3005251772089ab9aba50976151b3bbf1adff5f22cfe605f6426737f3fbd473d6051d0a490652b82f7b8f818b9c3e41fc2882636fdf2d100189f662d3f1f636a55eb821c88b0464791cdfc7a6b14cefaebf2317983508cc307f9ab119e5336b5e10ae67c483f0c406beddffa33146fb660a/rez-file-1739250280638.png",
    },
    {
      title:
        '"Designing Effective Community Development, Creating Shared Value (CSV) & Exit Strategy" Workshop by ISA Academy',
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/e6531cbce2f271fae490185af131920efb5a8644e3453c3a2b89ecff7d494573cc38aabe1fae352c22d81f7ae9cb7964d5d70394d1d79078aac3c4f72284fe8caaff9b76cfc09d800bafe69fa7335bb237e74dfa5a75ffc93175c21c61eb90f003ba5b6402f0d7308639f6948f2dccb928d51b6c056d227137a6/rez-file-1739249955044.png",
    },
    {
      title: '"ESG 101 Workshop" by Pertamina International Shipping',
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/29641ed9bd0543794cecb4a0dbea95a4952e84c5ac7206832bf356068223eebc51143067ac05a5c1a8041748b63db811bdfc1afc7346e4b152ffd2241df96900f227c8fdd9110e0b283b6be9acc471f35ae1014e2d816b4dbe9e27cdac2b9c3ec7b2e9c0ead165cc74df6a32d3926ce4635c68910ebd8a9a095c/rez-file-1739249668717.png",
    },
    {
      title: '"CSV Training" with ITM',
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/a79ef352092d9a17844fda530daa0dcc0d4f0f3babee49d195729980fd94b8ea6efa79ae1a96c55fc00f3e8c28993d1e6085cdde1c168097fbe29c49281560425ef6248420c3ef4c38427af6812b3bd59b95bbe8fe44733c09e60dde2b50b15f784f1156a93ff791c03fe9a98690a0519409b572c756aaa30734/rez-file-1739249695946.png",
    },
    {
      title: '"ESG Integration Training" with BOD of Indo Tambangraya Tengah',
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/c231301d44d629876a1f8fed5b606894342ecbe4a1609bc8f1d9de9fa0cef09b57c3435288e7f2aa6f4baba36eef088144dadfb4c75aca1832011b762b3da621ab448e25d5658c5162306c1bac8aa167f290e5df97f741995f78ad9cd8d383d749462edcecb7a0e9cd3598f8d4715d694c826511cadac4916a0f/rez-file-1739249713002.png",
    },
    {
      title: '"Sustainable Development Goals (SDGs) Training" with Mind ID',
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/8d3c21a52e1f8f9bd1fa6e8e9cfd6e00f8aea29bf027f12f548624b8766a9286d4116cb4ab731691c057fa29cfa856c09d43e856e28441c7b34fcd06a1aa457e6bed486f2cc47a386e5638968ceebb5efebf195f933e150405bf0c61ca5f4e03e1b8cb6521a403700a5199ab5268bfa436b02326f26eb7eceb70/rez-file-1739249733172.png",
    },
    {
      title: '"ESG Rating Analysis Training" with Telkom Indonesia',
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/b631be1d83436ef0749b9d19a5df88afbcd9db7513183030e9f5c17538d11212b4fa8317e21b64b00e81191cb66c3b99d63b77482fa0f2e64a40f213732dcad9ddb1ff340b3569e51fe41ddbb7888c06d243ea72ae334e77b42fdd1ded7e9ed8359637a40c8a98695aabfee4cd4e9a39f77fbfc3555c4f60ffb5/rez-file-1739249751201.png",
    },
    {
      title:
        '"ESG & Responsible Business Training" with Indonesian Ministry of Industry',
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/c7c77b4b318655a71cbb24531674b488bc1764733c6ee21e15657b55060555f10639f4a2f438566dd62e23b9e4d02a7c27ca106e236d7a448be24ab9085a365fc00579e3734a89ff56f4d5c6d87195e185e209f31db58568c0dd1ff332c0dd515c8625622709219b04ce0ab72658bef036352767ac4b36193a88/rez-file-1739249770668.png",
    },
    {
      title: '"ESG & ESG Rating Discussion" with PT Polytama Propindo',
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/0459eef9f177328780b0083a21408a9187c3c224eeb95e0cbe09849a56707dd7590dcb2ec949022e3a7708bdf98a066f159ef1bcf3dbe869ddd8142f2ab7ee64b11495ed9fd7a444ff6f65bc0ee66d46c6c4cdfda95781e81a5fb03a67330c1e9a7f63a951480e750a884b174a0b8bbf8b0a075fb66e40f19363/rez-file-1739249791734.png",
    },
  ];

  const clients_logo = [
    {
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/1fa01c6a5ccaf5547beec886be467e918c2a2c31c4d596d63eb2c37b04138c98f97fe0c6bf145d67aab0a48ce48116b9e2f4f57033f4195e39f67e608894d731d71dc0f0cd712b91857194fef46cceef3efad7e29398999fba7f14725e9037f9f69e7637c5e0937567d671ffe0547783c9eb14d32887f6744bd9/rez-file-1739771214136.png",
      title: "united_tractors_logo",
    },
    {
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/9511168a8335768963b7e250e63a3111ae48b9a24adc973efe100a699485152f65e7f2167a5fe0a68e55143a7567fa13e3621f0d5dba9fa901740f2332add19012a7a380e3381f1aec04e7cc54ad35402e94afd7416ef1ac4daea9a9c75b0b1f0384fda31114764e7379b9c3976f368c7ed1c5bcfb159e7004cd/rez-file-1739771195372.png",
      title: "pis_logo",
    },
    {
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/60df70ec2e40e147bc39733d339aa195c4f5146a90f09bef47161b4457ac299e5dbade6dc62cb7002346d2ade3aa188a96aea8a7994851e68e6f83d5b0b16e8418915a0c6fa0d291ba4e212879a37186d4b200390ca89711e7f673b63ef8fc358fb22a69b0b9ae4ca39ec80188c6967381c1a3985e3f0f695471/rez-file-1739771692727.png",
      title: "itm_logo",
    },
    {
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/5077525aa7d9d9d74b567a95dfbd4ae61244704d785490effecbbdf7417f84da9cb45c3848976f1ea34de92dcfa3ba1adb2c929dc0fcedc2a2f038c97d9bb6825273051a07e6990ae5c252edc5359adb56fde150a59fc2ff6d66ca8e39b0972fcbed591934034f6c38ec39633f37d57e4c6a8d54dc365e0b11d1/rez-file-1739771231108.png",
      title: "telkom_logo",
    },
    {
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/57e7c8bddf1260fcc073ac048145c24fe0d4a97f2610ef185d7f0db6d1d3e6369340c87811ae8062f0c11208aa4f71149c9456caced679e6f2eb3f67c8e7592eb5631fb527cf7a275812b7f6f0d38ca879866c274ee4406441291bcb7b07a0d0684b41830dd68211f8375bee04fe79df2b2092e630dc60c9e194/rez-file-1739771246049.png",
      title: "mind_id_logo",
    },
  ];

  const services = [
    {
      title: "CCS Online Consultation",
      description: (
        <>
          <p className="text-sm text-justify md:text-base xl:text-lg app-animation-translate-start">
            Currently serves as the only institutions to offer{" "}
            <b>
              online consulting through the Combined Clinics for Sustainability
              (CCS). We provide a discussion partner, called a ThinkPartner
            </b>
            , to explore issues, challenges, opportunities, and inspirations in
            areas such as{" "}
            <b>
              ESG, CSR, Community Development, Entrepreneurship, Leadership,
              Social Entrepreneurship, and Sustainability.
            </b>
          </p>
          <p className="text-sm text-justify md:text-base xl:text-lg app-animation-translate-start">
            Now, you can book an online consultation through our website, simply
            anywhere and just fingertip away, which will directly connect you to
            our ThinkPartner – a Sustainability Expert.
          </p>
        </>
      ),
      hrefUrl: "/ccs-investment",
    },
    {
      title:
        "Diploma of Project Management for ESG Projects with Australia Certification",
      description: (
        <p className="text-sm text-justify md:text-base xl:text-lg app-animation-translate-start">
          Our <b>Diploma of Project Management for ESG Projects</b> is a
          specialized program designed for professionals who want to lead and
          manage projects with a strong focus on{" "}
          <b>Environmental, Social, and Governance (ESG) principles</b>. This
          course equips students with industry-relevant project management
          skills while integrating <b>sustainability and ethical governance</b>{" "}
          into real-world project execution.
        </p>
      ),
      slug: "diploma-project-management-esg",
    },
    {
      title: "Leadership in Sustainability",
      description: (
        <p className="text-sm text-justify md:text-base xl:text-lg app-animation-translate-start">
          Our <b>Leadership for Education</b> program is designed to equip{" "}
          <b>educators, administrators, and academic leaders</b> with the
          knowledge and skills to integrate{" "}
          <b>
            Sustainability, ESG (Environmental, Social, and Governance), and
            Entrepreneurship
          </b>{" "}
          into educational leadership and curriculum development. Through{" "}
          <b>customized in-house training</b>, we help institutions foster
          future-ready leaders who can drive{" "}
          <b>positive environmental and social impact</b> while encouraging{" "}
          <b>innovation and sustainable business practices</b> in education.
        </p>
      ),
      slug: "leadership-sustainability",
    },
    {
      title: "ESG Workshop & Inhouse Training Topics",
      description: (
        <p className="text-sm text-justify md:text-base xl:text-lg app-animation-translate-start">
          Our{" "}
          <b>
            ESG (Environmental, Social, and Governance) Workshops & In-House
            Training
          </b>{" "}
          programs are designed to help organizations, businesses, and
          educational institutions integrate{" "}
          <b>sustainability, ethical leadership, and responsible governance</b>{" "}
          into their operations. Delivered by industry experts, our sessions
          provide{" "}
          <b>
            practical insights, real-world case studies, and actionable
            strategies
          </b>{" "}
          to enhance ESG performance and compliance.
        </p>
      ),
      slug: "esg-workshop-training",
    },
    {
      title: "CSR Workshop & Inhouse Training Topics",
      description: (
        <p className="text-sm text-justify md:text-base xl:text-lg app-animation-translate-start">
          Our{" "}
          <b>
            Corporate Social Responsibility (CSR) Workshops & In-House Training
          </b>{" "}
          programs are designed to help organizations{" "}
          <b>develop and implement impactful CSR strategies</b> that align with
          business goals while driving positive social and environmental change.
          Led by <b>industry experts</b>, our interactive training sessions
          equip teams with the <b>knowledge, tools, and best practices</b> to
          enhance CSR initiatives and create meaningful stakeholder engagement.
        </p>
      ),
      slug: "csr-workshop-training",
    },
    {
      title: "Social Entrepreneurship Workshop & Inhouse Trainings",
      description: (
        <p className="text-sm text-justify md:text-base xl:text-lg app-animation-translate-start">
          Our <b>Social Entrepreneurship Workshops & In-House Training</b>{" "}
          programs are designed to equip individuals, businesses, and
          organizations with the <b>skills, strategies, and mindset</b> needed
          to create <b>impact-driven ventures</b> that address social and
          environmental challenges. Whether you're an entrepreneur, educator,
          corporate leader, or nonprofit professional, our expert-led sessions
          will help you{" "}
          <b>
            develop sustainable business models, drive innovation, and scale
            social impact.
          </b>
        </p>
      ),
      slug: "social-entrepreneurship-workshop-training",
    },
  ];

  const banners = [
    {
      img_url:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/25708212d8c5e137294fe7ba0ad7baae4ce269c444086d80c0cdc85e602a4f8e5184556e4a039c3d9b54f528894634179c4925716df56a1400eb9db3ef2ebed69675bd481f55d5c33cec7892e2dd4b7f0d3025a58549e877d0a6b4d6afb885378ef627df505e501bc008c01cfca3a2046fd1ecd43c1afcacd8a4/rez-file-1739775349512.jpg",
      alt: "banner_1",
      label: "Our Education Programs To Create Leaders In Sustainability",
    },
    {
      img_url: banner_2,
      alt: "banner_2",
      label:
        "Introducing Our Online Consultation – a New Way to Consult on ESG, CSR, and Sustainability",
      button: true,
      buttonLabel: "Book consultation now",
      buttonHref: "/ccs-investment",
    },
  ];

  const buttonStyle = {
    position: "absolute",
    zIndex: "1",
    cursor: "pointer",
    border: "none",
    outline: "none",
    backgroundColor: "transparent",
    color: "#000000",
    fontSize: "80px",
    padding: "20px",
    borderRadius: "50%",
  };

  const properties = {
    prevArrow: (
      <button
        className="arrow arrow-left"
        style={{ ...buttonStyle, left: 30 }}
        hidden
      >
        <span>&lt;</span>
      </button>
    ),
    nextArrow: (
      <button
        className="arrow arrow-right"
        style={{ ...buttonStyle, right: 30 }}
        hidden
      >
        <span>&gt;</span>
      </button>
    ),
  };

  return (
    <div>
      <section>
        <Slide {...properties}>
          {banners.map((slideImage, idx) => {
            const { img_url, alt, label, button, buttonLabel, buttonHref } =
              slideImage;
            return (
              <div className="relative" key={idx}>
                <img
                  src={img_url}
                  alt={alt}
                  className="max-h-[80vh] w-full object-cover object-bottom"
                />
                <div className="absolute top-0 bottom-0 left-0 right-0 text-white bg-app-orange/10">
                  <div className="flex flex-col items-start justify-center h-full gap-4 app-main-container sm:gap-8">
                    <div className="text-2xl/[2rem] sm:text-4xl/[4rem] lg:text-6xl/[5rem] max-w-6xl text-center leading-2 font-bold app-animation-translate-start text-white ">
                      {label}
                    </div>
                    {button && buttonLabel && buttonHref ? (
                      <div className="flex items-center justify-center w-full align-center">
                        <a
                          className="bg-[#0864FB] sm:px-4 sm:py-3 px-8 py-4 text-white text-center rounded-xl text-md/[.5rem] sm:text-md/[.5rem] lg:text-2xl/[2rem] xl:text-2xl/[2rem] font-bold"
                          href={buttonHref}
                        >
                          {buttonLabel}
                        </a>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            );
          })}
        </Slide>
      </section>

      {/* <section className='grid grid-cols-1 sm:grid-cols-2'>
        <div>
          <img src="https://assets.skor.id/crop/136x76:1228x690/x/photo/2020/10/05/1364398555.jpg" alt="main" className='object-cover object-top w-full h-full aspect-video app-animation-scale-start' />
        </div>
        <div className='flex items-center justify-center px-4 py-6 text-white bg-app-black-2 md:py-12 md:px-10 lg:px-20 sm:justify-start'>
          <p className='max-w-xs text-lg font-semibold text-center sm:text-xl md:text-2xl sm:font-bold sm:text-left app-animation-translate-start'>{t('firstHighlightText')}</p>
        </div>
      </section> */}

      <section className="bg-app-light-gray/10">
        <div className="mx-auto px-4 py-6 sm:px-12 sm:py-8; max-w-lg sm:max-w-3xl md:max-w-[110rem] app-animation-translate-start">
          <div className="flex flex-col items-center justify-between gap-4 p-8 my-3 md:flex-row md:gap-0 bg-app-orange/30 rounded-xl md:p-10 app-animation-translate-start">
            <p className="text-center md:text-left text-xl/[2rem] sm:text-2xl/[2rem] lg:text-3xl/[3rem] xl:text-4xl/[3rem] font-bold">
              Check out our upcoming ISA Academy Workshop catalogue
            </p>
            <div className="w-full md:w-[600px] 2xl:w-auto flex justify-center md:justify-end">
              <a
                className="bg-[#0864FB] px-8 py-4 text-white text-center rounded-xl text-xl/[2rem] sm:text-2xl/[2rem] lg:text-3xl/[3rem] xl:text-4xl/[3rem] font-bold"
                href={ISAAcademyWorkshopCatalogue}
                target="_blank"
                download={"ISA-Academy-2025-Workshop-Catalog.pdf"}
                rel="noopener noreferrer"
              >
                Download Now
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-app-light-gray/10">
        <div className="space-y-8 app-main-container">
          <p className="pt-3 pb-2 text-xl font-bold text-center md:pt-6 md:pb-4 md:text-2xl xl:text-4xl text-app-dark-blue app-animation-translate-start">
            About Us
          </p>
          <div>
            <img
              src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/2b9707d2dac9efa09e6d8ef81e351bf587b8739fd64dd1ff361cb8713be471c4fb9308cb05a20e460e54c49bd74b7faf45a1a1756992e5b3dd79694e0ddc06a75b19a243f3cf108ad2955ee3c1a3bf6abb166a60b3d2d71ae27191ea42c1d4526c20e3e429bcd7be679886dfa959658d7787d69357e51f33c8e9/file-1739179092805.png "
              alt="main"
              className="object-cover object-center w-4/5 py-4 mx-auto sm:w-3/5 app-animation-scale-start"
            />
          </div>
          <div className="pt-3 pb-4 space-y-6 md:pt-6 md:pb-8">
            <p className="text-sm text-justify md:text-base xl:text-lg app-animation-translate-start">
              <b>PT Inhocsigno Hominum Salvator (IHS)</b> is a forward-thinking
              education company committed to shaping the next generation of
              leaders in sustainability through our brand- ISA Academy. We
              believe that education is the key to driving meaningful change,
              and we are dedicated to equipping individuals with the knowledge,
              skills, and mindset needed to address the world's most pressing
              environmental and social challenges.
            </p>
            <p className="text-sm text-justify md:text-base xl:text-lg app-animation-translate-start">
              Through innovative programs, strategic partnerships, and hands-on
              experiential learning, we provide a transformative educational
              experience that goes beyond traditional learning methods.
            </p>
            <p className="text-sm text-justify md:text-base xl:text-lg app-animation-translate-start">
              Our curriculum integrates cutting-edge research, real-world case
              studies, and interdisciplinary approaches to sustainability,
              ensuring that our students gain a comprehensive understanding of
              global issues and practical solutions.
            </p>
            <p className="text-sm text-justify md:text-base xl:text-lg app-animation-translate-start">
              At <b>PT Inhocsigno Hominum Salvator (IHS)</b>, we collaborate
              with experts, institutions, and industry leaders to create
              impactful learning opportunities, mentorship programs, and
              leadership development initiatives. Our goal is to inspire and
              empower individuals to become changemakers—leaders who can drive
              sustainable policies, implement ethical business practices, and
              foster resilient communities.
            </p>
            <p className="text-sm text-justify md:text-base xl:text-lg app-animation-translate-start">
              With a strong emphasis on innovation, responsibility, and global
              impact, we are committed to shaping a future where sustainability
              is not just an ideal but a fundamental principle guiding
              decision-making across all sectors. Through education, we aim to
              create a world where future generations can thrive in harmony with
              the environment.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-app-dark-gray/10">
        <div className="space-y-8 app-main-container">
          <p className="pt-3 pb-2 text-xl font-bold text-center md:pt-6 md:pb-4 md:text-2xl xl:text-4xl text-app-dark-blue app-animation-translate-start">
            Our Services
          </p>
          <div className="grid grid-cols-1 gap-8 pt-2 pb-6 md:grid-cols-2 md:gap-12 md:pt-4 md:pb-12">
            {services.map((services, i) => {
              return (
                <div
                  key={i}
                  className="flex flex-col gap-6 p-8 rounded-lg bg-app-orange/80 md:gap-8 app-animation-translate-start"
                >
                  <p className="text-xl font-bold text-white md:text-2xl lg:text-3xl app-animation-translate-start">
                    {services.title}
                  </p>
                  {services.description}
                  <a
                    className="flex items-center gap-2 font-bold app-animation-translate-start"
                    href={
                      services && services.slug
                        ? `/services/${services.slug}`
                        : `${services.hrefUrl}`
                    }
                  >
                    <p className="text-sm md:text-base xl:text-lg">
                      Learn More
                    </p>
                    <ArrowRightIcon className="w-3 h-3 sm:w-4 sm:h-4 fill-black" />
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="bg-app-light-gray/10">
        <div className="space-y-8 app-main-container">
          <p className="pt-3 pb-2 text-xl font-bold text-center md:pt-6 md:pb-4 md:text-2xl xl:text-4xl text-app-dark-blue app-animation-translate-start">
            Our Activities
          </p>
          <div className="grid grid-cols-1 gap-10 pt-2 pb-6 sm:grid-cols-2 md:gap-12 md:pt-4 md:pb-12">
            {activity_posts.map((item, i) => (
              <div
                key={i}
                className="flex flex-col gap-4 md:gap-6 app-animation-scale-start"
              >
                <img
                  className="bg-[#F5EEE2] mx-auto sm:w-full aspect-[4/3] object-contain border rounded-lg"
                  src={item.img_url}
                  alt={item.title}
                />
                <p className="text-lg font-bold text-center xl:text-xl">
                  {item.title}
                </p>
                {/* <p className='text-xs font-semibold truncate sm:text-base text-app-black'>{item.summary}</p>
                <a href={`article/${item?.id}`} className='flex items-center gap-2 text-xs sm:text-sm '>
                  <p>{t('learnMore')}</p>
                  <ArrowRightIcon className='w-2 h-2 sm:h-3 sm:w-3 fill-black' />
                </a> */}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-app-dark-gray/10">
        <div className="space-y-8 app-main-container">
          <p className="pt-3 pb-2 text-xl font-bold text-center md:pt-6 md:pb-4 md:text-2xl xl:text-4xl text-app-dark-blue app-animation-translate-start">
            Our Clients
          </p>
          <div className="grid items-center grid-cols-2 gap-6 pt-2 pb-6 md:grid-cols-3 md:gap-8 place-items-center md:pt-4 md:pb-12">
            {clients_logo.map((logo, idx) => {
              return (
                <img
                  key={idx}
                  src={logo.img_url}
                  className="w-[300px] h-[100px] object-center object-contain app-animation-scale-start"
                  alt="client-logo"
                />
              );
            })}
          </div>
        </div>
      </section>

      <section className="bg-app-light-gray/10">
        <div className="space-y-8 app-main-container">
          <p className="pt-3 pb-2 text-xl font-bold text-center md:pt-6 md:pb-4 md:text-2xl xl:text-4xl text-app-dark-blue app-animation-translate-start">
            Our Legal Information
          </p>
          <div className="pt-2 pb-4 space-y-4 md:pt-4 md:pb-8">
            <p className="text-xs md:text-sm xl:text-base app-animation-translate-start">
              <b>Nama Perusahaan:</b> PT INHOCSIGNO HOMINUM SALVATOR - IHS
            </p>
            <p className="text-xs md:text-sm xl:text-base app-animation-translate-start">
              <b>Nomor SK Pengesahan:</b> AHU-0033583.AH.01.01.Tahun 2024
            </p>
            <p className="text-xs md:text-sm xl:text-base app-animation-translate-start">
              <b>Tanggal Pendirian:</b> 13 Mei 2024
            </p>
            <p className="text-xs md:text-sm xl:text-base app-animation-translate-start">
              <b>Skala Usaha:</b> Usaha Mikro
            </p>
            <p className="text-xs md:text-sm xl:text-base app-animation-translate-start">
              <b>Informasi Rekening:</b> INHOCSIGNO HOMINUM SALVA (Full Company
              Name: INHOCSIGNO HOMINUM SALVATOR)
            </p>
            <p className="text-xs md:text-sm xl:text-base app-animation-translate-start">
              <b>Nomor Rekening:</b> 1728999810
            </p>
            <p className="text-xs md:text-sm xl:text-base app-animation-translate-start">
              <b>Nama Bank:</b> BCA KCP Foresta
            </p>
            <p className="text-xs md:text-sm xl:text-base app-animation-translate-start">
              <b>Swift Code:</b> CENAIDJA
            </p>
            <p className="text-xs md:text-sm xl:text-base app-animation-translate-start">
              <b>Alamat Bank:</b> Kavling Commercial Foresta Lot I-1, Lengkong
              Kulon, Pagedangan, Kab. Tangerang, Banten, Kabupaten Tangerang,
              DKI Jakarta 15331
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
